import React, { useEffect, useState } from "react";
import "./register.style.scss";
import { Button, Checkbox, Input } from "antd";
import CircularProgress from "@material-ui/core/CircularProgress";
import { post, responseValidator } from "../../api";
import { toast } from "react-toastify";
import moment from "moment";
export default function Register(props) {
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState("");
    const [cpassword, setcpassword] = useState("");
    const [refralCode, setRefralCode] = useState(undefined);
    const [isChecked, setIsChecked] = useState(false);

    function onCLickHandler() {
        if (password === cpassword &&
            password.length >= 6 &&
            password.match(/[0-9]/g) &&
            isChecked) {
            setLoading(true)
            const body = {
                phoneNumber: localStorage.getItem("phone"),
                password: password
            };
            if (props.state === 3 && props.refral) body.referralCode = props.refral;
            else if (props.state === 3 && !props.refral)
                body.referralCode = refralCode;
            post(
                `/User/${props.state === 3 ? "SetPassword" : "ResetPassword"}`,
                body
            ).then(response => {
                setLoading(false);
                if (responseValidator(response.status)) {
                    localStorage.setItem("refToken", response.data.data.refresh_token);
                    localStorage.setItem("accessToken", response.data.data.access_token);
                    localStorage.setItem("tokenDate", moment.utc())
                    localStorage.setItem("roles", response.data.data.roles.toString());

                    window.location.replace("/userpanel/order");
                } else toast.error(response.data.message);
            });
        }

    }

    return (
        <div className="TEMX-register">
            <h2>تعیین رمز عبور</h2>
            <p>برای تکمیل فرآیند ثبت نام لطفا رمز عبور {props.state !== 3 && 'جدید'} خود را وارد نمایید</p>
            <div className="my-input">
                <Input value={localStorage.getItem("phone")} disabled={true} />
                <span style={{ height: "10px", display: "flex" }} />
                <Input.Password
                    autoComplete={false}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="رمز عبور"
                />
                <span style={{ height: "10px", display: "flex" }} />
                <Input.Password
                    onPressEnter={onCLickHandler}
                    autoComplete={"off"}
                    onChange={e => setcpassword(e.target.value)}
                    placeholder="تایید رمز عبور"
                />
                <span style={{ height: "10px", display: "flex" }} />
                {props.refral && props.state === 3 ? (
                    <Input value={props.refral} disabled={true} />
                ) : (
                    !props.refral &&
                    props.state === 3 && (
                        <Input
                            onChange={e => setRefralCode(e.target.value)}
                            value={refralCode}
                            placeholder="کد معرف"
                        />
                    )
                )}
            </div>
            <span style={{ height: "20px", display: "flex" }} />
            <p style={{ color: "#767b82" }}>
                رمز مورد نظر باید حداقل ۶ کاراکتر و شامل حروف و اعداد باشد
            </p>
            <Checkbox
                style={{ display: "flex", height: "15px" }}
                onChange={() => setIsChecked(!isChecked)}
            >
                <p>
                    با ثبت نام در تم ایکس{" "}
                    <a target="_blank" href="/page/laws/">
                        {" "}
                        قوانین و مقررات سایت
                    </a>{" "}
                    را می پذیرم
                </p>
            </Checkbox>
            <div className="my-btn">
                <Button
                    block
                    disabled={
                        password !== cpassword ||
                        password.length < 6 ||
                        !password.match(/[0-9]/g) ||
                        !isChecked
                    }
                    type="primary"
                    onClick={onCLickHandler}
                    loading={loading}
                >
                    تایید
                </Button>
            </div>

        </div>
    );
}
